export enum LinkedSocialProvider
{
  Google,
  Facebook,
  Apple,
}

export interface LinkedProviderInfo
{
  provider: LinkedSocialProvider;
  email:    string | null;
  name:     string | null;
}

const linked_providers: LinkedProviderInfo[] = [];

export function getLinkedSocialProviders(): LinkedSocialProvider[]
{
  return linked_providers.map( p => p.provider );
}

export function getLinkedProviderInfo( provider: LinkedSocialProvider ): LinkedProviderInfo | undefined
{
  return linked_providers.find( p => p.provider === provider );
}

export function hasLinkedSocialProvider( provider: LinkedSocialProvider ): boolean
{
  return linked_providers.some( p => p.provider === provider );
}

export function addLinkedSocialProvider( provider: LinkedSocialProvider, email: string | null = null, name: string | null = null ): void
{
  if ( hasLinkedSocialProvider( provider ) ) return;
  linked_providers.push( { provider, email, name } );
}

export function removeLinkedSocialProvider( provider: LinkedSocialProvider ): void
{
  const index = linked_providers.findIndex( p => p.provider === provider );
  if ( index !== -1 ) linked_providers.splice( index, 1 );
}

export function resetLinkedSocialProviders(): void
{
  linked_providers.length = 0;
}

const PROVIDER_ID_CACHE_KEYS: Record<string, string> = {
  google:   'web_google_id',
  facebook: 'web_facebook_id',
  apple:    'native_apple_id',
};

export function initLinkedProvidersFromServer( providers: Array<{ provider: string; provider_id?: string | null; email: string | null; name: string | null }> ): void
{
  const map: Record<string, LinkedSocialProvider> = {
    google:   LinkedSocialProvider.Google,
    facebook: LinkedSocialProvider.Facebook,
    apple:    LinkedSocialProvider.Apple,
  };
  for ( const p of providers )
  {
    const provider = map[ p.provider ];
    if ( provider !== undefined ) addLinkedSocialProvider( provider, p.email, p.name );

    if ( p.provider_id )
    {
      const cache_key = PROVIDER_ID_CACHE_KEYS[ p.provider ];
      if ( cache_key ) localStorage.setItem( cache_key, p.provider_id );
    }
  }
}
